/* global axios */
import ApiClient from '../ApiClient';

class ArrowsAiDocumentsAPI extends ApiClient {
  constructor() {
    super('arrows_ai/assistants', { accountScoped: true });
  }

  get({ assistantId } = {}) {
    return axios.get(`${this.url}/${assistantId}/documents`);
  }

  create({ assistantId, files } = {}) {
    const body = new FormData();
    Array.from(files || []).forEach(file => body.append('files[]', file));
    return axios.post(`${this.url}/${assistantId}/documents`, body);
  }

  delete({ assistantId, id } = {}) {
    return axios.delete(`${this.url}/${assistantId}/documents/${id}`);
  }

  download({ assistantId, id } = {}) {
    return axios.get(`${this.url}/${assistantId}/documents/${id}/download`, {
      responseType: 'blob',
    });
  }

  content({ assistantId, id } = {}) {
    return axios.get(`${this.url}/${assistantId}/documents/${id}/content`);
  }

  updateContent({ assistantId, id, content } = {}) {
    return axios.patch(`${this.url}/${assistantId}/documents/${id}/content`, {
      content,
    });
  }
}

export default new ArrowsAiDocumentsAPI();
